import { CUSTOM_ELEMENTS_SCHEMA, Injector, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { createCustomElement } from '@angular/elements';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { MdbPopoverModule } from 'mdb-angular-ui-kit/popover';
import { MdbChartModule } from 'mdb-angular-ui-kit/charts';

import { IconModule } from 'app/icon/icon.module';

import { CoreModule } from '../core/core.module';

import * as guestInformationList from './features/guest-information-list.reducer';
import { GuestInformationListEffects } from './features/guest-information-list.effects';

import { GuestInformationListComponent } from './components/guest-information-list/guest-information-list.component';

@NgModule({
  declarations: [
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MdbChartModule,
    IconModule,
    CoreModule,
    MdbPopoverModule,
    ClipboardModule,
    StoreModule.forFeature(guestInformationList.guestInformationListFeatureKey, guestInformationList.reducer),
    EffectsModule.forFeature([GuestInformationListEffects]),
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class GuestInformationListModule { 
  constructor(injector:Injector){
    const GuestInformationListElement = createCustomElement(GuestInformationListComponent,{injector});

    try {
      customElements.define('paybee-guest-information-list-element', GuestInformationListElement)
    } catch(e) {}

  }

}
